/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner3 from './Banner3';
import Content4 from './Content4';

import { Banner30DataSource, Content40DataSource } from './data.source';
import './less/antMotionStyle.less';
import Footer1 from "../Home/Footer1";
import Nav0 from "../Home/Nav0";
import { Footer10DataSource, Nav00DataSource } from "../Home/data.source";
import BreadcrumbCon from "../components/BreadcrumbCon";
import TextCon from "../components/TextCon";
import CarouselCon from '../components/CarouselCon';
import NewsImgCon from '../components/NewsImgCon';
import { NewsDetailDataSource } from "../common/globalDataList";

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { location } = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: !location.port, // 如果不是 dva 2.0 请删除
        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */
        if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
            setTimeout(() => {
                this.setState({
                    show: true,
                });
            }, 500);
        }
        /* 如果不是 dva 2.0 请删除 end */
    }

    render() {
        let IndustryList = [
            { img: "img/coreBusiness1.png", icon: "img/icon1.png", text: "大气环境数据分析及应用", },
            { img: "img/coreBusiness2.png", icon: "img/icon2.png", text: "大气污染耦合解析与达标规划", },
            { img: "img/coreBusiness3.png", icon: "img/icon4.png", text: "空气质量预报预警", },
            { img: "img/coreBusiness4.png", icon: "img/icon3.png", text: "大气环境网格化辅助决策", },
        ];
        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}
            />,
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"}>
                <BreadcrumbCon pageName={"新闻资讯"} pagePath={"/news"} />
            </div>,
            <div style={{ background: 'rgb(248,248,248)', }}>
                <div className={"container"} style={{ minHeight: '60vh', }}>
                    <CarouselCon title={"公司新闻 / Company News"} list={window.newsList}
                    />
                </div>
            </div>,
            <div className={"container"} style={{ minHeight: '50vh', }}>
                <NewsImgCon title={"行业资讯 / Industry Information"} list={IndustryList}
                    showMore={() => window.location.href = '/news2'}
                />
            </div>,
            <Content4
                id="Content4_0"
                key="Content4_0"
                dataSource={Content40DataSource}
                isMobile={this.state.isMobile}
            />,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];
        return (
            <div
                className="templates-wrapper"
                ref={(d) => {
                    this.dom = d;
                }}
            >
                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {this.state.show && children}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}
